import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Paper from '@mui/material/Paper';
import { PanelHeader } from '../../../../panels/panelHeader';
import { PanelContainer } from '../../../../panels/panelStyles';
import { useAppSelector } from '../../../../redux/store';
import { ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR } from '../../../../styles/colors';
import { PANEL_CONTENT_PADDING_STRING } from '../../../../styles/styles';
import { TourneyStandingsPlayersContainer } from './tourneyStandingsPlayersContainer';
const PAPER_CSS = css `
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: ${ROOM_INFO_PANEL_LIST_BACKGROUND_COLOR} !important;
  padding: 0;
`;
export const TourneyStandingsPanel = () => {
    const numActivePlayers = useAppSelector((state) => state.mtt.activePlayers.length);
    const numFinishedPlayers = useAppSelector((state) => state.mtt.finishedPlayers.length);
    return (_jsxs(PanelContainer, { padding: PANEL_CONTENT_PADDING_STRING, children: [_jsx(PanelHeader, { title: 'Tourney Standings' }), _jsxs(Paper, { "aria-label": 'tourney standings', component: 'section', css: PAPER_CSS, children: [numActivePlayers > 0 && (_jsx(TourneyStandingsPlayersContainer, { header: 'Active Players', playerType: 'active', showChips: true })), numFinishedPlayers > 0 && (_jsx(TourneyStandingsPlayersContainer, { header: 'Finished Players', playerType: 'finished', showChips: false }))] })] }));
};
